import React from "react";
import classnames from "classnames";
import ReactHtmlParser from "react-html-parser";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Translate } from "react-localize-redux";
import { withRouter } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bindActionCreators } from "redux";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { newsActions } from "../../store/newsStore";
import { popupActions } from "../../store/popupStore";
import { isNullOrUndefined } from "../../store/storeFunctions";

import CrossIcon from "../../img/icons/Cross";
import CalendarIcon from "../../img/icons/Kalendar";

import "./notifications.scss";

class Notifications extends React.Component {
    render() {
        const data = this.props.dataNotif;

        return (
            <div className="notifications-wrapper">
                <div className="picker-row-notif" />
                <PerfectScrollbar ref={(el) => (this._scrollRef = el)} className="notifications">
                    <TransitionGroup>
                        {Array.isArray(data) && data.map((i) => <CSSTransition timeout={250}
                            key={`${i.news ? "news" : "notification"}-${i.news ? i.news.newsId : i.notification.id}`}
                        >
                            <>
                                <div className={classnames("news-notification", { "with-pointer": this.isNewsClickable(i) })}
                                    onClick={(_) => this.onNotificationClick(i)}
                                >
                                    {i.notification && <>
                                        <div className="navmenu-notification">
                                            <div>
                                                {this.renderNewsDateHeader(i.notification.completedFormated)}
                                                <span className={i.notification.seen ? "" : "notif-no-seen"}>
                                                    {ReactHtmlParser(this.urlFormat(i.notification.description))}
                                                </span>
                                            </div>
                                            <div className="navmenu-notification-icon-wrapper">
                                                {i.notification.processing == true && <FontAwesomeIcon icon="cog" spin={true} />}
                                                {i.notification.processing !== true && <CrossIcon
                                                    className="navmenu-notification-icon cross"
                                                    size={window.innerWidth > 992 ? "1x" : "2x"}
                                                    onMouseDown={(e) => e.stopPropagation()}
                                                    onMouseUp={(e) => e.stopPropagation()}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        this.dissmiss(i.notification.id);
                                                    }}
                                                />}
                                            </div>
                                        </div>
                                    </>}
                                    {i.news && <>
                                        <div className="navmenu-news-content-wrapper">
                                            {this.renderNewsDateHeader(i.news.validFromFormated)}
                                            <div className="navmenu-news-content-header-wrapper">
                                                <h3 className="truncate title navmenu-news-content-header">
                                                    <div className="notif-seen">
                                                        {!i.news.seen && <div className="notif-seen-value"></div>}
                                                        <span className={classnames("truncate header-text", { seen: i.news.seen })}>
                                                            {i.news.header}
                                                        </span>
                                                    </div>
                                                </h3>
                                                <Link to={`/news/${i.news.newsId}`} className="link-internal content-more">
                                                    <FontAwesomeIcon className="navmenu-notification-more-icon" icon="angle-right" />
                                                </Link>
                                            </div>
                                            <div className="navmenu-news-content">
                                                <p className={classnames("truncate content-text", { seen: i.news.seen })}>
                                                    {ReactHtmlParser(this.props.getTextContent(!i.news.text ? "" : i.news.text))}
                                                </p>
                                            </div>
                                        </div>
                                    </>}
                                </div>
                                <hr />
                            </>
                        </CSSTransition>)}
                    </TransitionGroup>
                </PerfectScrollbar>
                <div className="notification-links-wrapper">
                    <a className="link-functional" onClick={(_) => this.props.updateNotificationsStatus(2)}>
                        <Translate id="Common.Dismiss" />
                    </a>
                    <Link to={`/news-notifications`} className={classnames("link-internal", { "is-normal": localStorage.locales_url_format === "normal" })}>
                        <Translate id="Report.Common.ShowAll" />
                    </Link>
                </div>
            </div>
        );
    }

    componentDidMount() {
        this.updateScrollbar();
        if (this.props.user.authentication.isAuthorized) {
            this.props.ensureNotifications();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.languageChanged) {
            this.props.resetConnection();
        }

        if (
            this.props.loadOlderNotifications > 0 &&
            this.props.loadOlderNotifications !== prevProps.loadOlderNotifications
        ) {
            this.props.fetchOlderNotifications();
        }

        if (
            !isNullOrUndefined(this.props.dataNotif) &&
            !isNullOrUndefined(prevProps.dataNotif) &&
            this.props.dataNotif.length !== prevProps.dataNotif.length &&
            this._scrollRef !== null &&
            this._scrollRef !== undefined
        ) {
            this.updateScrollbar();
        }

        let checkNews = localStorage.getItem("checkNews");
        if (!isNullOrUndefined(checkNews) && checkNews === "true") {
            checkNews = JSON.parse(checkNews);
            if (!isNullOrUndefined(checkNews) && checkNews === true) {
                this.props.ensureNewsCheck();
                if (!this.props.isLoadingCheck && this.props.dataCheck) {
                    localStorage.setItem("checkNews", false);
                    if (this.props.dataCheck.length > 0)
                        this.openPopup(this.props.dataCheck.pop());
                }
            }
        }
    }

    urlFormat = (description) => {
        if (
            description.match("link-internal") &&
            localStorage.locales_url_format === "normal"
        )
            return description.replace("link-internal", "link-internal is-normal");
        return description;
    };

    renderNewsDateHeader = (time) => (
        <div className="navmenu-news-date">
            <CalendarIcon className="calendar-icon" fill="#969DA1" />
            <span className="news-date">{time}</span>
        </div>
    );

    dissmiss(notifId) {
        this.props.updateNotificationsStatus(3, notifId);
    }

    updateScrollbar = () => {
        if (this._scrollRef !== null && this._scrollRef !== undefined) {
            this._scrollRef._ps.update(); // also needs to be called to update scrollbar after path change
            this._scrollRef.updateScroll();
        }
    };

    openPopup(item) {
        this.props.showPopup("newsPopup", {
            open: true,
            item: item,
            ok: () => {},
            setAllAsRead: () => {
                let itemIds = [];
                itemIds.push(item.newsId);
                if (this.props.dataCheck && this.props.dataCheck.length > 0) {
                    for (const news of this.props.dataCheck) {
                        itemIds.push(news.newsId);
                    }
                }
                this.updateNewsList(itemIds);
                this.props.hidePopup();
                this.props.history.push("/news");
            },
            close: (updateStatus) => {
                if (updateStatus) this.updateNewsList([item.newsId]);

                this.props.hidePopup();
                if (this.props.dataCheck.length > 0)
                    setTimeout(
                        function() {
                            //Start the timer
                            this.openPopup(this.props.dataCheck.pop());
                        }.bind(this),
                        500
                    );
            },
        });
    }

    updateNewsList = (ids) => {
        this.props.updateNewsStatus(ids);
    };

    onNotificationClick = (general) => {
        if (general.notification) {
            if (this.isNotificationClickable(general.notification)) {
                const guid = general.notification.description.match(/guid="([a-fA-F0-9-]+)"/);
                if (guid) {
                    window.open(this.props.generatePdfLink(guid[1]), "_blank");
                    this.props.updateNotificationsStatus(2, general.notification.id);
                } else {
                    const reqId = general.notification.description.match(/req-id="([0-9]+)"/);
                    if (reqId) {
                        window.open(this.props.generateMlExportLink(reqId[1]), "_blank");
                        this.props.updateNotificationsStatus(2, general.notification.id);
                    } else {
                        const exportId = general.notification.description.match(/export-id="([0-9]+)"/);
                        if (exportId) {
                            window.open(this.props.generateExportLink(exportId[1]), "_blank");
                            this.props.updateNotificationsStatus(2, general.notification.id);
                        } else {
                            const link = general.notification.description.match(/link-to="(.+)"/);
                            if (link) {
                                this.props.updateNotificationsStatus(2, general.notification.id);
                                this.props.history.push(link[1]);
                            }
                        }
                    }
                }
            }
        } else if (general.news) {
            this.props.history.push(`/news/${general.news.newsId}`);
        }
    };

    isNewsClickable = (general) =>
        general.news || this.isNotificationClickable(general.notification);

    isNotificationClickable = (notification) =>
        notification.description.indexOf('link-type="get-pdf"') !== -1 ||
        notification.description.indexOf('link-type="get-ml"') !== -1 ||
        notification.description.indexOf('link-to="') !== -1 ||
        notification.description.indexOf('link-type="get-export"') !== -1;
}

export default withRouter(connect(
    state => ({ ...state.news, user: state.userContext }),
    dispatch => bindActionCreators({ ...newsActions, ...popupActions }, dispatch)
)(Notifications));
